import React from 'react';
import styled from 'styled-components';
import { ColorTheme } from '../styling/theme';
import Button from './Button';

const Container = styled.div`
  height: 200px;
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

interface Props {
  message?: string;
  onRetry: () => void;
}

export default function ErrorPageView(props: Props) {
  const { message, onRetry } = props;

  return (
    <Container>
      <p>
        Something went wrong. <a href="#" onClick={onRetry}>Reload</a>
      </p>
    </Container>
  );
}